import React, { useState, useCallback } from 'react'

import { getStaticImage } from 'utils/statics'

import THeaderConfigPopUp from './THeaderConfigPopUp'

import './styles.scss'

const GearButton = ({ fields, onChange, className='' }) => {
  const [isOpen, setIsOpen] = useState(false)
  const onCloseModal = useCallback(() => setIsOpen(false), [])
  return (
    <div>
      <img onClick={()=> setIsOpen(!isOpen)}
        className={`tableConfig ${className}`}
        width={20}
        src={getStaticImage('/icons/orange-brand/icon-settings.svg')}
        alt='Close'
      />
      {isOpen && <THeaderConfigPopUp
        fields={fields}
        isOpen={isOpen}
        onChange={onChange}
        onClose={onCloseModal} />}
    </div>
  )
}

export default GearButton